import Landing from '../views/Landing.vue';
import AboutUs from '../views/AboutUs.vue';
import SidekickSearch from '../views/SidekickSearch.vue';
import SnkrhudNewDirection from '../views/Blog/SnkrhudNewDirection.vue';
import AirJordanXxxvi from '../views/Blog/AirJordanXxxvi.vue';
import SnkrBlog from '../views/Blog/SnkrBlog.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';
import GettingStarted from '../views/GettingStarted.vue';
import JoinSnkrhudCommunity from '../views/JoinSnkrhudCommunity.vue';
import TermsAndCondition from '../views/TermsAndCondition.vue';

const routes = [
  {
    path: '/',
    component: Landing,
    name: 'Landing',
  },
  {
    path: '/about-us',
    component: AboutUs,
    name: 'AboutUs',
  },
  {
    path: '/sidekick-search',
    component: SidekickSearch,
    name: 'SidekickSearch',
  },
  {
    path: '/blog',
    component: SnkrhudNewDirection,
    name: 'SnkrhudNewDirection',
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicy,
    name: 'privacypolicy',
  },
  {
    path: '/meet-the-team-behind-the-air-jordan-xxxvi',
    component: AirJordanXxxvi,
    name: 'AirJordanXxxvi',
  },
  {
    path: '/snkr-blog',
    component: SnkrBlog,
    name: 'SnkrBlog',
  },
  {
    path: '/getting-started',
    component: GettingStarted,
    name: 'GettingStarted',
  },
  {
    path: '/join-snkrhud-community',
    component: JoinSnkrhudCommunity,
    name: 'JoinSnkrhudCommunity',
  },
  {
    path: '/terms-and-condition',
    component: TermsAndCondition,
    name: 'TermsAndCondition',
  },
];

export default routes;
